module.exports = new __parcel__URL__("blob_hud_image.3fa847b7.png").toString();